@if (label(); as label) {
  <label
    [for]="innerId()"
    data-test="dropdown-label"
  ><span>{{ label }}</span>
    @if (selectedNode()) {
      <b (mousedown)="clearNode($event);">(Clear)</b>
    }
  </label>
}
<p-tree-select
  [inputId]="innerId()"
  [showClear]="true"
  [options]="treeData().children"
  [placeholder]="placeholder()"
  [ngModel]="selectedNode()"
  (ngModelChange)="handleSelection($event)"
  [filter]="filter()"
>
  <ng-template pTemplate="triggericon">
    <svg class="p-icon" width="18" height="18" viewBox="0 0 18 18" fill="currentColor">
      <use [attr.xlink:href]="SvgSpriteIcon.ArrowDownSLine"></use>
    </svg>
  </ng-template>

  <ng-template #clearicon>
    <svg class="p-icon" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <use [attr.xlink:href]="SvgSpriteIcon.Close"></use>
    </svg>
  </ng-template>
</p-tree-select>
